import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '@': 'track',
  },
  variables: {
    healthCheckRecordId: '?1.1',
  },
  subqueries: {
    track: {
      filter: {
        '=': [
          {
            '@$': 'healthCheckRecordId',
          },
          {
            '@.': '!id',
          },
        ],
      },
      target: 'ent:!health-check:!track',
      quantity: 1,
      selection: {
        '{}': {
          name: {
            '@.': '!name',
          },
          type: 'report-card',
          content: {
            '@': 'dimensions',
          },
        },
      },
      subqueries: {
        dimensions: {
          target: 'ent:!health-check:!dimension',
          selection: {
            '{}': {
              name: {
                '@.': '!name',
              },
              values: {
                '@': 'criteria',
              },
            },
          },
          subqueries: {
            criteria: {
              target: 'ent:!health-check:!criteria',
              selection: {
                '{}': {
                  name: {
                    '@.': '!name',
                  },
                  value: {
                    '{}': {
                      quality: {
                        if: [
                          [
                            {
                              not: {
                                '>=': [
                                  {
                                    '@.': '!score',
                                  },
                                  60,
                                ],
                              },
                            },
                            'bad',
                          ],
                          [
                            {
                              '>': [
                                {
                                  '@.': '!score',
                                },
                                80,
                              ],
                            },
                            'good',
                          ],
                        ],
                      },
                      tooltip: {
                        '@.': '!descr',
                      },
                      emphasis: {
                        'fmt.num': [
                          {
                            '@.': '!score',
                          },
                          {
                            suffix: '%',
                          },
                        ],
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}
